module.exports = __webpack_public_path__ + "img/home.0bfa705f.svg";